<template>
  <div id="nav">
    <div class="header">
      <div class="columns is-gapless">
        <div class="column is-narrow logo">          
            <div class="eureko-logo-white"></div>
            <img v-if="affinityImgUrl" class="separator">
            <img v-if="affinityImgUrl" :src="affinityImgUrl" class="partner-img" :alt="affinityTitle">          
        </div>
        <!-- <div class="column is-1">
          <div class="republic100thYearAnniversary-logo"></div>
        </div> -->
        <div class="column">
          <!-- <div class="newYear" v-if="showNewYear"></div> -->
          <Menu />
        </div>
        <div class="column is-middle whatsapp">
          <Whatsapp />
        </div>
        <div class="column is-1 is-middle language">
          <Language />
        </div>
        <div class="column is-narrow">
          <div class="columns">
            <div class="column is-narrow">
              <HeaderSearch />
            </div>
            <template v-if="!loginActive">
              <div class="column is-narrow">
                <OnlineOffice />
              </div>  
            </template>            
            <template v-if="loginActive">
              <div class="column is-narrow is-middle">
                <PostHeader />
              </div>
            </template>          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Menu from '@/desktop/widget/header/menu'
import HeaderSearch from '@/desktop/widget/header/search'
import OnlineOffice from '@/desktop/widget/header/onlineOffice'
import PostHeader from '@/desktop/widget/post/PostHeader'
import service from '@/service'
import Language from '@/shared/widget/header/language'
import Whatsapp from '@/shared/widget/header/whatsapp'
export default {
  name: 'Header',
  components: {
    OnlineOffice,
    HeaderSearch,
    Menu,
    PostHeader,
    Language,
    Whatsapp
  },
  data () {
    return {
      search: null,
      showMenu: false,
      loginActive: false,
      affinityImgUrl: '',
      affinityTitle: '',
      intervalControl: null,
      showNewYear: false
    }
  },
  mounted () {
    var self = this
    this.showSnow()
    var nav = document.getElementsByClassName('header')[0]
    var offset = nav.getBoundingClientRect()
    var tmp = nav.cloneNode(true)
    tmp.style.visibility = 'hidden'

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > offset.top) {
        // if (nav.parentNode.contains(tmp)) {
        //   nav.parentNode.removeChild(tmp)
        // }
        nav.parentNode.appendChild(tmp)

        nav.style.setProperty('position', 'fixed')
        nav.style.top = 0
        nav.style.width = '100%'
      } else {
        // nav.parentNode.appendChild(tmp)
        if (nav.parentNode.contains(tmp)) {
          nav.parentNode.removeChild(tmp)
        }
        nav.style.setProperty('position', 'static')
        nav.style.top = ''
      }
    })

    service.content.getAffinity(this).then(function (result) {
      if (result !== null) {
        self.affinityTitle = result.title
        self.affinityImgUrl = result.url
      }
    })
    this.checkLogin()
  },
  methods: {
    showSnow () {
      var currentDate = new Date()
      if ((currentDate.getMonth() === 11 && currentDate.getDate() >= 15) || (currentDate.getMonth() === 0 && currentDate.getDate() <= 2)) {
        this.showNewYear = true
      }
    },
    checkLogin: function () {
      this.loginActive = this.isLogin()
    },
    checkLoginState: function () {
      this.intervalControl = setInterval(() => {
        this.checkLogin()
      }, 5000)
    }
  },
  created: function () {
    this.eventHub.$on('login', this.checkLogin)
    this.eventHub.$on('logout', this.checkLogin)
    // this.checkLoginState()
  },
  beforeDestroy: function () {
    this.eventHub.$off('login', this.checkLogin)
    this.eventHub.$off('logout', this.checkLogin)
    clearInterval(this.intervalControl)
  }
}
</script>
<style scoped>
.newYear {
  background-image: url("/static/img/snow.png");
  width: 100%;
  height: 100px;
  position: fixed;
  margin-top: -20px;
  opacity: 0.3;
}
.header {
  background-color: var(--dark-bg2);
  z-index: 100;
  padding: 15px;
}
.header .logo {
  margin-right: 30px !important;
}
.header .logo .logo-img {
  margin-left: 10px;
}
.header .logo img, img.partner-img {
  height: 35.5px;
}
.separator {
  background: #cee3ea;
  width: 1px;
  height: 45px !important;
  border: 0;
  margin: -7px 10px;
}
.is-middle.language {
  max-width: 45px;
  z-index: 99;
}
.is-middle.whatsapp {
  max-width: 150px;  
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  z-index: 99;
}
@media only screen and (min-width: 1400px) {
  .header .inner-header {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/desktop/widget/header.vue